"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function toggleInCallPip(isVisible) {
    if (isVisible === void 0) { isVisible = null; }
    return {
        type: constants_1.app.actions.toggleInCallPip,
        payload: isVisible
    };
}
exports.toggleInCallPip = toggleInCallPip;
function togglePipPreview(isVisible) {
    if (isVisible === void 0) { isVisible = null; }
    return {
        type: constants_1.app.actions.togglePipPreview,
        payload: isVisible
    };
}
exports.togglePipPreview = togglePipPreview;
function togglePresentationPrompt(isVisible) {
    if (isVisible === void 0) { isVisible = null; }
    return {
        type: constants_1.app.actions.togglePresentationPrompt,
        payload: isVisible
    };
}
exports.togglePresentationPrompt = togglePresentationPrompt;
function changeVolumeInCall(value) {
    if (value === void 0) { value = 0.5; }
    return {
        type: constants_1.app.actions.changeVolumeInCall,
        payload: value
    };
}
exports.changeVolumeInCall = changeVolumeInCall;
function setIsLegacyServiceDegraded(value) {
    if (value === void 0) { value = true; }
    return {
        type: constants_1.app.actions.setIsLegacyServiceDegraded,
        payload: value
    };
}
exports.setIsLegacyServiceDegraded = setIsLegacyServiceDegraded;
function setHdmiPresentationConnected(value) {
    if (value === void 0) { value = false; }
    return {
        type: constants_1.app.actions.setHdmiPresentationConnected,
        payload: value
    };
}
exports.setHdmiPresentationConnected = setHdmiPresentationConnected;
function setHdmiPresentationActive(value) {
    if (value === void 0) { value = false; }
    return {
        type: constants_1.app.actions.setHdmiPresentationActive,
        payload: value
    };
}
exports.setHdmiPresentationActive = setHdmiPresentationActive;
function setSharePresentationInfo(value) {
    if (value === void 0) { value = null; }
    return {
        type: constants_1.app.actions.setSharePresentationInfo,
        payload: value
    };
}
exports.setSharePresentationInfo = setSharePresentationInfo;
function setSharePinCode(value) {
    if (value === void 0) { value = null; }
    return {
        type: constants_1.app.actions.setSharePinCode,
        payload: value
    };
}
exports.setSharePinCode = setSharePinCode;
function setSharePresentationActive(value) {
    if (value === void 0) { value = false; }
    return {
        type: constants_1.app.actions.setSharePresentationActive,
        payload: value
    };
}
exports.setSharePresentationActive = setSharePresentationActive;
function setSipIncomingCall(value) {
    if (value === void 0) { value = null; }
    return {
        type: constants_1.app.actions.setSipIncomingCall,
        payload: value
    };
}
exports.setSipIncomingCall = setSipIncomingCall;
function setSipActiveCall(value) {
    if (value === void 0) { value = null; }
    return {
        type: constants_1.app.actions.setSipActiveCall,
        payload: value
    };
}
exports.setSipActiveCall = setSipActiveCall;
function selectCallLayout(layout) {
    if (layout === void 0) { layout = ''; }
    return {
        type: constants_1.app.actions.selectCallLayout,
        payload: layout
    };
}
exports.selectCallLayout = selectCallLayout;
function showMeetingStartPrompt(value) {
    if (value === void 0) { value = null; }
    return {
        type: constants_1.app.actions.showMeetingStartPrompt,
        payload: value
    };
}
exports.showMeetingStartPrompt = showMeetingStartPrompt;
